import React, {useRef, useState, useEffect, useCallback, Fragment} from "react";
import Column from "@amzn/meridian/column";
import Textarea from "@amzn/meridian/textarea"
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import { CSVLink } from 'react-csv';
import Text from "@amzn/meridian/text";
import {batchGetPackageSummary} from "../../../commons/api/BatchGetPackageSummaryResults.js";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";
import Divider from "@amzn/meridian/divider"
import {
    oldTimeZoneMapper,
    handleBlankValue,
    createDimensionString,
    createRouteSortCode,
    getExchangeType,
    getFeatureStatus
} from "../../../commons/CommonUtils.js";
import Box from "@amzn/meridian/box";
import Select, { SelectOption } from "@amzn/meridian/select";
import Toaster from "@amzn/meridian/toaster";
import Alert from "@amzn/meridian/alert";
import Loader from "@amzn/meridian/loader";
import Popover, { PopoverHeader } from "@amzn/meridian/popover";
import ControlGroup from "@amzn/meridian/control-group";
import Checkbox from "@amzn/meridian/checkbox";
import { FormattedMessage, injectIntl } from "react-intl";
import {getServiceType, isFERegion, isINRegion, convertArrayToString, fetchAssociate} from "../../../util/CommonUtils";
import {handlePackageStateMapping, handlePackageReasonMapping} from "../../../commons/CommonUtils.js";
import RefreshTimer from "../../../commons/RefreshTimer";
import {useDeviceLayout} from "../../../commons/context/DeviceLayoutContext";
import { FEATURES } from "../../../commons/constants/CommonConstants";

const PackageSearchTab = (props) => {

    var initialInputValue = "";
    var initialPackageOutputList = [];

    //Total Sizes for search results
    const batchSize = isFERegion() ? 50: 500;
    const totalSize = 5000;

    const [sortState, setSortState] = useState({sortDirection : "ascending"});
    const [inputValue, setInputValue] = useState(initialInputValue);
    const [toasters, setToasters] = useState([]);
    const [loaderOn, setLoaderOn] = useState(false);
    const [loaderProgress, setLoaderProgress] = useState(0);

    //View options visible state
    const [optionVisible, setOptionVisible] = useState(false);
    const defaultColumnOptions = ['Tracking ID', 'Last Updated Time', 'Source', 'State', 'Destination', 'Reason', 'Station', 'Operation', 'Route Code', 'Last Scan By', 'Address Type', 'Ship Option', 'Ship Method', 'Delivery Destination Type'];
    const [viewOptionColumns, setViewOptionColumns] = useState(defaultColumnOptions);
    const [allViewOptionsSelected, setAllViewOptionsSelected] = useState(false);
    const onClickOptionButton = useCallback(() => setOptionVisible(true), [])
    const onCloseOptionButton = useCallback(() => setOptionVisible(false), [])
    //Filter within result option visible state
    const [filterWithinResult, setFilterWithinResult] = useState(false);
    //All column download checkbox
    const [columnCheck, setColumnCheck] = useState(false);
    //Filter States start
    const [processedBySelectFilter, setProcessedBySelectFilter] = useState([]);
    const [routeSelectFilter, setRouteSelectFilter] = useState([]);
    const [sortZoneSelectFilter, setSortZoneSelectFilter] = useState([]);
    const [stationSelectFilter, setStationSelectFilter] = useState([]);
    //Filter States end
    const [packageList, setPackageList] = useState(initialPackageOutputList);
    const [displayedList, setDisplayedList] = useState(initialPackageOutputList);
    const [sortedDisplayedList, setSortedDisplayedList] = useState(initialPackageOutputList);

    const [errorInput, setErrorInput] = useState(false);
    const csvLink = React.useRef();
    const csvLink2 = useRef();
    const optionButtonRef = useRef();
    const [addressFieldsEnabled, setAddressFieldsEnabled] = useState(false);
    const [hazmatVisibilityEnabled, setHazmatVisibilityEnabled] = useState(false);
    const [isInternalPDDEnabled, setIsInternalPDDEnabled] = useState(false);
    const [isShipperNameEnabled, setIsShipperNameEnabled] = useState(false);
    const {isMobile, spacingInset_shorthand6} = useDeviceLayout();

    useEffect(() => {
        const checkFeatureFlag = async () => {
            const isEnabled = await getFeatureStatus(FEATURES.IS_PACKAGE_SEARCH_INTERNAL_PDD_ENABLED);
            const isShipperNameVisible = await getFeatureStatus(FEATURES.IS_SHIPPER_NAME_ENABLED);
            setIsInternalPDDEnabled(isEnabled);
            setIsShipperNameEnabled(isShipperNameVisible);
        };
        checkFeatureFlag();
    }, []);

    const fetchPackageSummary = async (listPackageIds) => {
        try {
            return await batchGetPackageSummary(listPackageIds, props.nodeId, setLoaderProgress, batchSize);
        } catch (e) {
            return null;
        }
    }
    const sentenceCase = (str) => {
        if ((str===null) || (str===''))
             return null;
        else
            str = str.toString();

        if (str.toLowerCase() === "fdd")
            return str;

        return str.toLowerCase().replace(/_/g," ").replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
    }
    const searchPath = "#/detailPage/";

    const getPackageShareableLink = (trackingId)  => {
        const shareablePath = "detailPage/";
        const redirectPath = new URL(props.baseURL);
        redirectPath.searchParams.set("shareableLink", shareablePath.concat(trackingId));
        return redirectPath;
    };

    const convertToString = (param) =>  {

        return param && param !== null ? param.toString() : ""
    }

    useEffect(() => {
        switch(sortState.sortDirection) {
            case 'ascending': setSortedDisplayedList(displayedList.concat().sort((a, b) =>  convertToString(a[sortState.sortColumn]).localeCompare(convertToString(b[sortState.sortColumn])), 'en', { numeric: true })); break;
            case 'descending' : setSortedDisplayedList(displayedList.concat().sort((a,b)=>  convertToString(b[sortState.sortColumn]).localeCompare(convertToString(a[sortState.sortColumn])), 'en', { numeric: true })); break;
            default : break;
        }
    }, [sortState, displayedList]);

    const displayViewOptions = () => {
        var finalResult = [];

        finalResult = finalResult.concat(<Checkbox value={'Select All'} checked={viewOptionColumns.includes('Select All')}>{props.intl.formatMessage({id: 'search.package.searchTabResult_selectAll'})}</Checkbox>);

        finalResult = finalResult.concat(headers.filter(header => viewOptionColumns.includes(header.label))
            .filter(header => header.label !== 'Select All').map(header => {
                if (header.label === 'Tracking ID') {
                    return <Checkbox disabled={true} value={header.label}>{props.intl.formatMessage({id: headersToStringId.find((stringId) => stringId.header === header.label).value})}</Checkbox>;
                }
                return <Checkbox value={header.label}>{props.intl.formatMessage({id: headersToStringId.find((stringId) => stringId.header === header.label).value})}</Checkbox>;

            }));
        var nonSelectedColumns = headers.filter(header => !viewOptionColumns.includes(header.label))
            .filter(header => header.label !== 'Select All').map(header => header.label).concat().sort();

        finalResult = finalResult.concat(nonSelectedColumns.map(header => {
            if (header === 'Tracking ID') {
                return <Checkbox disabled={true}
                                 value={header}>{props.intl.formatMessage({id: headersToStringId.find((stringId) => stringId.header === header).value})}</Checkbox>;
            }
            return <Checkbox
                value={header}>{props.intl.formatMessage({id: headersToStringId.find((stringId) => stringId.header === header).value})}</Checkbox>;
        }));

        return finalResult;
    }

    const handleViewOptionsColumnChange = changeEvent => {

        if (allViewOptionsSelected === false && changeEvent.includes('Select All')) {
            changeEvent = headers.map(header => header.label);
            setAllViewOptionsSelected(true);
        } else if (allViewOptionsSelected) {
            changeEvent = changeEvent.includes('Select All') ? changeEvent.filter(event => event !== 'Select All')
                : defaultColumnOptions;
            setAllViewOptionsSelected(false);
        }
        setViewOptionColumns(changeEvent);
    }

    const onClickSearch = () => {
        if (inputValue && inputValue.trim()) {
            setLoaderOn(true);
            let commaSeparatedInputs = inputValue.split(/,\s*/);
            let tempListPackageIds = commaSeparatedInputs.map(commaSeparatedInput => {
                return commaSeparatedInput.trim().split(/\s+/);
            })
            let listPackageIds = [].concat.apply([], tempListPackageIds).filter(Boolean).filter((v, i, a) => a.indexOf(v) === i);
            if (listPackageIds.length > totalSize) {
                setToasters([{ id: props.intl.formatMessage({id: 'search.package.searchTabResult_maxLimitPackage'}), timeout: 3000}]);
                listPackageIds = listPackageIds.slice(0, totalSize);
            }

            fetchPackageSummary(listPackageIds).then((result) => {
                let finalResult = result.packageSummaryList;
                if (finalResult.filter(Boolean) <= 0) {
                    setToasters([{ id: props.intl.formatMessage({id: 'search.package.searchTabResult_noResults'}), timeout: 3000}]);
                }
                setPackageList(enrichPackageList(finalResult.filter(Boolean)));
                setAddressFieldsEnabled(result.addressFieldsEnabled);
                setHazmatVisibilityEnabled(result.hazmatVisibilityEnabled);
                setLoaderOn(false);
            });
        } else {
            setErrorInput(true);
        }
    }

    let headers = [
        { label: 'Select All', key: 'selectAll' },
        { label: 'Tracking ID', key: 'trackingId' },
        { label: 'Last Updated Time', key: 'lastUpdatedTime' },
        { label: 'Source', key: 'source' },
        { label: 'State', key: 'currentPackageState' },
        { label: 'Destination', key: 'destination' },
        { label: 'Reason', key: 'reasonCode' },
        { label: 'Station', key: 'currentStationCode' },
        { label: 'Operation', key: 'operation' },
        { label: 'Route Code', key: 'currentRouteCode' },
        { label: 'Last Scan By', key: 'lastProcessedByAssociateName' },
        { label: 'Address Type', key: 'addressType' },
        { label: 'Ship Option', key: 'shipOption' },
        { label: 'Ship Method', key: 'shipMethod' },
        { label: 'Delivery Destination Type', key: 'deliveryDestinationType' },
        { label: 'Cluster', key: 'cluster' },
        { label: 'Aisle', key: 'aisle' },
        { label: 'Dispatch Time', key: 'dispatchTime' },
        { label: 'DSP Name', key: 'dspFlex' },
        { label: 'Assigned Cycle', key: 'assignedCycle' },
        { label: 'Inducted Cycle', key: 'inductedCycle' },
        { label: 'Minutes in State', key: 'minutesInState' },
        { label: 'Last Scan location', key: 'lastScanLocation' },
        { label: 'Expected Next Location', key: 'expectedNextLocation' },
        { label: 'Last Scan Status', key: 'lastScanStatus' },
        { label: 'Payment Method', key: 'paymentMethod' },
        { label: 'District', key: 'district' },
        { label: 'Shipment Type', key:'shipmentType' },
        { label: 'Ship Date', key: 'shipDate' },
        { label: 'Scheduled Delivery Start Time', key: 'scheduledDeliveryStart' },
        { label: 'Scheduled Delivery End Time', key: 'scheduledDeliveryEnd' },
        { label: 'Promised Delivery Date', key: 'promisedDeliveryDate' },
        { label: 'Sort Zone', key: 'assignedSortZone' },
        { label: 'Warehouse', key: 'warehouse' },
        { label: 'Manifest Route Code', key: 'manifestRouteCode' },
        { label: 'Order Amount', key: 'orderAmount' },
        { label: 'Driver Id', key: 'driverId' },
        { label: 'Package Length', key: 'packageLength' },
        { label: 'Package Width', key: 'packageWidth' },
        { label: 'Package Height', key: 'packageHeight' },
        { label: 'Package Weight', key: 'packageWeight' },
        { label: 'Estimated Arrival Date', key: 'estimatedArrivalDate' },
        { label: 'Ordering Order ID', key: 'orderingOrderId' },
        { label: 'Route Sequence', key: 'routeSequence' },
        { label: 'Route Sort Code', key: 'routeSortCode' },
        { label: 'Receivable Amount', key: 'receivableAmount'},
        { label: 'Holder Name', key: 'lockerName' },
        { label: 'Service Type', key: 'serviceType' },
        { label: 'SAL Color', key: 'salColor' }
    ];

    let headersToStringId = [
        { header: 'Select All', value: 'search.package.searchTabResult_selectAll' },
        { header: 'Tracking ID', value: 'search.package.searchTabResult_trackingId' },
        { header: 'State', value: 'search.package.searchTabResult_status' },
        { header: 'Reason', value: 'search.package.searchTabResult_reason' },
        { header: 'Last Updated Time', value: 'search.package.searchTabResult_lastUpdated' },
        { header: 'Last Scan By', value: 'search.package.searchTabResult_processedBy' },
        { header: 'Route Code', value: 'search.package.searchTabResult_route' },
        { header: 'Cluster', value: 'search.package.searchTabResult_cluster' },
        { header: 'Aisle', value: 'search.package.searchTabResult_aisle' },
        { header: 'Dispatch Time', value: 'search.package.searchTabResult_dispatchTime' },
        { header: 'DSP Name', value: 'search.package.searchTabResult_dspFlex' },
        { header: 'Assigned Cycle', value: 'search.package.searchTabResult_assignedCycle' },
        { header: 'Inducted Cycle', value: 'search.package.searchTabResult_inductedCycle' },
        { header: 'Minutes in State', value: 'search.package.searchTabResult_minutesInState' },
        { header: 'Last Scan location', value: 'search.package.searchTabResult_lastScanLocation' },
        { header: 'Expected Next Location', value: 'search.package.searchTabResult_expectedNextLocation' },
        { header: 'Last Scan Status', value: 'search.package.searchTabResult_lastScanStatus' },
        { header: 'Payment Method', value: 'search.package.searchTabResult_paymentMethod' },
        { header: 'District', value: 'search.package.searchTabResult_district' },
        { header: 'Shipment Type', value: 'search.package.searchTabResult_shipmentType'},
        { header: 'Ship Date', value: 'search.package.searchTabResult_shipDate' },
        { header: 'Scheduled Delivery Start Time', value: 'search.package.searchTabResult_scheduledDeliveryStart' },
        { header: 'Scheduled Delivery End Time', value: 'search.package.searchTabResult_scheduledDeliveryEnd' },
        { header: 'Promised Delivery Date', value: 'search.package.searchTabResult_promisedDeliveryDate' },
        { header: 'Ship Option', value: 'search.package.searchTabResult_shipOption' },
        { header: 'Ship Method', value: 'search.package.searchTabResult_shipMethod' },
        { header: 'Sort Zone', value: 'search.package.searchTabResult_sortzone' },
        { header: 'Warehouse', value: 'search.package.searchTabResult_warehouse' },
        { header: 'Station', value: 'search.package.searchTabResult_station' },
        { header: 'Manifest Route Code', value: 'search.package.searchTabResult_manifestRouteCode' },
        { header: 'Order Amount', value: 'search.package.searchTabResult_orderAmount' },
        { header: 'Address Type', value: 'search.package.searchTabResult_addressType' },
        { header: 'Driver Id', value: 'search.package.searchTabResult_driverId' },
        { header: 'Package Length', value: 'search.package.searchTabResult_packageLength' },
        { header: 'Package Width', value: 'search.package.searchTabResult_packageWidth' },
        { header: 'Package Height', value: 'search.package.searchTabResult_packageHeight' },
        { header: 'Package Weight', value: 'search.package.searchTabResult_packageWeight' },
        { header: 'Operation', value: 'search.package.searchTabResult_operation' },
        { header: 'Delivery Destination Type', value: 'search.package.searchTabResult_deliveryDestinationType' },
        { header: 'Estimated Arrival Date', value: 'search.package.searchTabResult_estimatedArrivalDate' },
        { header: 'Destination', value: 'search.package.searchTabResult_destination' },
        { header: 'Source', value: 'search.package.searchTabResult_source' },
        { header: 'Ordering Order ID', value: 'search.package.searchTabResult_orderingOrderId'},
        { header: 'Route Sequence', value: 'search.package.searchTabResult_routeSequence' },
        { header: 'Route Sort Code', value: 'search.package.searchTabResult_routeSortCode' },
        { header: 'Receivable Amount', value: 'search.package.searchTabResult_receivableAmount'},
        { header: 'Holder Name', value: 'search.package.searchTabResult_holderName' },
        { header: 'Service Type', value: 'search.package.searchTabResult_serviceType' },
        { header: 'SAL Color', value: 'search.package.searchTabResult_salColor' }

    ];

    if (addressFieldsEnabled) {
        headers = headers.concat([
            { label: 'City', key: 'city'},
            { label: 'Postal', key: 'postal'},
            { label: 'Province', key: 'province'},
            { label: 'Exchange', key: 'exchangeId'}
        ]);

        headersToStringId = headersToStringId.concat([
            { header: 'City', value: 'search.package.searchTabResult_city'},
            { header: 'Postal', value: 'search.package.searchTabResult_postal'},
            { header: 'Province', value: 'search.package.searchTabResult_province'},
            { header: 'Exchange', value: 'search.package.searchTabResult_exchange'}
        ]);
    }

    if (hazmatVisibilityEnabled) {
        headers = headers.concat([
            { label: 'Hazmat Exception', key: 'hazmatExceptions' },
            { label: 'Hazmat Label ID', key: 'hazmatRegulatoryIds' }
        ]);

        headersToStringId = headersToStringId.concat([
            { header: 'Hazmat Exception', value: 'search.package.searchTabResult_hazmatException' },
            { header: 'Hazmat Label ID', value: 'search.package.searchTabResult_hazmatLabelId' }
        ]);
    }
    if (isInternalPDDEnabled) {
        headers = headers.concat([
            { label: 'Internal Promised Delivery Date', key: 'internalPromisedDeliveryDate' }
        ]);

        headersToStringId = headersToStringId.concat([
            { header: 'Internal Promised Delivery Date', value: 'search.package.searchTabResult_internalPromisedDeliveryDate' }
        ]);
    }
    if (isINRegion()) {
        headers = headers.concat([
            { label: 'Package Count', key: 'packageCount'},
            { label: 'Store Name', key: 'holderEmployeeStoreId'}
        ]);

        headersToStringId = headersToStringId.concat([
            { header: 'Package Count', value: 'search.package.searchTabResult_packageCount'},
            { header: 'Store Name', value: 'search.package.searchTabResult_storeName'}
        ]);
    }
    if(isShipperNameEnabled) {
        headers = headers.concat([
            { label: 'Shipper Name', key: 'shipperName' }
        ]);

        headersToStringId = headersToStringId.concat([
            { header: 'Shipper Name', value: 'search.package.searchTabResult_shipperName' }
        ]);

    }
    useEffect(() => {
        if (inputValue) {
            setErrorInput(false);
        }
    }, [inputValue]);

    useEffect(() => {
        setLoaderProgress(0);
    }, [loaderOn]);

    const generatePackageFilteredList = () => {
        let processedByFilteredList = processedBySelectFilter.length > 0 ? packageList.filter(packageData => processedBySelectFilter.includes(packageData.lastProcessedByAssociateName)) : packageList;
        let routeFilteredList = routeSelectFilter.length > 0 ? processedByFilteredList.filter(packageData => routeSelectFilter.includes(packageData.currentRouteCode)) : processedByFilteredList;
        let stationFilteredList = stationSelectFilter.length > 0 ? routeFilteredList.filter(packageData => stationSelectFilter.includes(packageData.currentStationCode)) : routeFilteredList;
        let sortZoneFilteredList = sortZoneSelectFilter.length > 0 ? stationFilteredList.filter(packageData => sortZoneSelectFilter.includes(packageData.assignedSortZone)) : stationFilteredList;
        setDisplayedList(sortZoneFilteredList);
    }

    useEffect(() => {
        if (packageList.length <= batchSize) {
            generatePackageFilteredList();
        }

    }, [sortZoneSelectFilter, processedBySelectFilter, routeSelectFilter, stationSelectFilter, packageList]);

    useEffect(() => {
        if (packageList.length > batchSize) {
            csvLink2.current.link.click();
        }
    }, [packageList]);

    const enrichPackageList = (packageList) => {
        return packageList.map(packageDetail => {

            let dateTimeOptions = {
                timeZone: packageDetail.stationTimeZone ? oldTimeZoneMapper(packageDetail.stationTimeZone) : undefined
            }

            let lastUpdatedTime = packageDetail.lastUpdatedTime ? new Date(packageDetail.lastUpdatedTime).toLocaleString('sv-SE', dateTimeOptions) : '';
            let dispatchTime = packageDetail.dispatchTime ? new Date(packageDetail.dispatchTime).toLocaleString('sv-SE', dateTimeOptions) : '';
            let additionalAttributes = packageDetail.additionalAttributes ? packageDetail.additionalAttributes : {};

            

            let dateOptions = {
                day: "2-digit",
                year: "numeric",
                month: "2-digit",
                timeZone: packageDetail.stationTimeZone ? oldTimeZoneMapper(packageDetail.stationTimeZone) : undefined
            };

            let packageLength = packageDetail.packageLength && packageDetail.packageLength.value ? packageDetail.packageLength.value.toFixed(2) : null;
            let packageLengthUnit = packageDetail.packageLength && packageDetail.packageLength.unit ? packageDetail.packageLength.unit.toLowerCase() : null;
            let packageWidth = packageDetail.packageWidth && packageDetail.packageWidth.value ? packageDetail.packageWidth.value.toFixed(2) : null;
            let packageWidthUnit = packageDetail.packageWidth && packageDetail.packageWidth.unit ? packageDetail.packageWidth.unit.toLowerCase() : null;
            let packageHeight = packageDetail.packageHeight && packageDetail.packageHeight.value ? packageDetail.packageHeight.value.toFixed(2) : null;
            let packageHeightUnit = packageDetail.packageHeight && packageDetail.packageHeight.unit ? packageDetail.packageHeight.unit.toLowerCase() : null;
            let packageWeight = packageDetail.packageWeight && packageDetail.packageWeight.value ? packageDetail.packageWeight.value.toFixed(2) : null;
            let packageWeightUnit = packageDetail.packageWeight && packageDetail.packageWeight.unit ? packageDetail.packageWeight.unit.toLowerCase() : null;

            let dspFlex = additionalAttributes["PROVIDER_ID"] && additionalAttributes["PROVIDER_ID"].value ? additionalAttributes["PROVIDER_ID"].value : '';
            let shipMethod = additionalAttributes["SHIP_METHOD"] && additionalAttributes["SHIP_METHOD"].value ? additionalAttributes["SHIP_METHOD"].value: '';
            let estimatedArrivalDate = additionalAttributes["ESTIMATED_ARRIVAL_DATE"] && additionalAttributes["ESTIMATED_ARRIVAL_DATE"].value ? new Date(additionalAttributes["ESTIMATED_ARRIVAL_DATE"].value).toLocaleString('sv-SE', dateOptions) : '';
            let promisedDeliveryDate =
                packageDetail.promisedDeliveryDate ?
                    new Date(packageDetail.promisedDeliveryDate).toLocaleString('sv-SE', dateOptions) :
                    (additionalAttributes["PROMISED_DELIVERY_DATE"] && additionalAttributes["PROMISED_DELIVERY_DATE"].value ? new Date(additionalAttributes["PROMISED_DELIVERY_DATE"].value).toLocaleString('sv-SE', dateOptions) : '');
            let internalPromisedDeliveryDate = packageDetail.internalPromisedDeliveryDate ? new Date(packageDetail.internalPromisedDeliveryDate).toLocaleString('sv-SE', dateTimeOptions) : '';
            let shipmentType = additionalAttributes["SHIPMENT_TYPE"] && additionalAttributes["SHIPMENT_TYPE"].value ? additionalAttributes["SHIPMENT_TYPE"].value : '';
            let shipOption = packageDetail.shipOption ? packageDetail.shipOption : '';
            let shipDate = additionalAttributes["SHIP_DATE"] && additionalAttributes["SHIP_DATE"].value ? new Date(additionalAttributes["SHIP_DATE"].value).toLocaleString('sv-SE', dateTimeOptions) : '';
            let scheduledDeliveryTime = additionalAttributes["SCHEDULED_DELIVERY_TIME"] && additionalAttributes["SCHEDULED_DELIVERY_TIME"].value ? new Date(additionalAttributes["SCHEDULED_DELIVERY_TIME"].value).toLocaleString('sv-SE', dateTimeOptions) : '';
            let scheduledDeliveryStart = packageDetail.scheduledDeliveryStart ? new Date(packageDetail.scheduledDeliveryStart).toLocaleString('sv-SE', dateTimeOptions) : '';
            let scheduledDeliveryEnd = packageDetail.scheduledDeliveryEnd ? new Date(packageDetail.scheduledDeliveryEnd).toLocaleString('sv-SE', dateTimeOptions) : '';
            let operation = packageDetail.operation ? packageDetail.operation : '';
            let routeSequence = packageDetail.routeSequence ? packageDetail.routeSequence: '';
            let salColor = packageDetail.salColor ? packageDetail.salColor: '';
            let vehicleStopNumber = packageDetail.vehicleStopNumber ? packageDetail.vehicleStopNumber : '';
            let taskStopNumber = packageDetail.taskStopNumber ? packageDetail.taskStopNumber : '';
            let serviceType = getServiceType(packageDetail.serviceType);
            let hazmatExceptions = convertArrayToString(packageDetail.hazmatExceptions);
            let hazmatRegulatoryIds = convertArrayToString(packageDetail.hazmatRegulatoryIds);
            if (isINRegion()) {
                shipmentType = packageDetail.shipmentType ? packageDetail.shipmentType : '';
            }
            return {
                trackingId : packageDetail.trackingId,
                currentPackageState : handlePackageStateMapping("SEARCH", "ALL", sentenceCase(packageDetail.currentPackageState), "DEFAULT_VIEW"),
                reasonCode : handlePackageReasonMapping("SEARCH", "ALL", sentenceCase(packageDetail.reasonCode)),
                lastUpdatedTime: lastUpdatedTime,
                lastProcessedByAssociateName: packageDetail.lastProcessedByAssociateName,
                currentStationCode: packageDetail.currentStationCode,
                currentRouteCode: packageDetail.currentRouteCode,
                assignedSortZone: packageDetail.assignedSortZone,
                dspFlex: dspFlex,
                shipMethod: shipMethod,
                estimatedArrivalDate: estimatedArrivalDate,
                promisedDeliveryDate: promisedDeliveryDate,
                internalPromisedDeliveryDate: internalPromisedDeliveryDate,
                shipmentType: shipmentType,
                shipOption: shipOption,
                shipDate: shipDate,
                scheduledDeliveryTime: scheduledDeliveryTime,
                packageLength: createDimensionString(packageLength, packageLengthUnit),
                packageWidth: createDimensionString(packageWidth, packageWidthUnit),
                packageHeight: createDimensionString(packageHeight, packageHeightUnit),
                packageWeight: createDimensionString(packageWeight, packageWeightUnit),
                driverId: packageDetail.driverId,
                warehouse: packageDetail.warehouse,
                addressType: packageDetail.addressType,
                orderAmount: packageDetail.orderAmount,
                manifestRouteCode: packageDetail.manifestRouteCode,
                source: packageDetail.source,
                destination: packageDetail.destination,
                lastScanLocation: packageDetail.lastScanLocation,
                aisle: packageDetail.aisle,
                cluster: packageDetail.cluster,
                district: packageDetail.district,
                minutesInState: packageDetail.minutesInState,
                scheduledDeliveryStart: scheduledDeliveryStart,
                scheduledDeliveryEnd: scheduledDeliveryEnd,
                assignedCycle: packageDetail.assignedCycle,
                inductedCycle: packageDetail.inductedCycle,
                dispatchTime: dispatchTime,
                paymentMethod: packageDetail.paymentMethod,
                attendant: packageDetail.attendant,
                operation: operation,
                deliveryDestinationType : packageDetail.deliveryDestinationType,
                expectedNextLocation: packageDetail.expectedNextLocation ? packageDetail.expectedNextLocation : '',
                city: packageDetail.city,
                postal: packageDetail.postal,
                province: packageDetail.province,
                exchangeId: getExchangeType(packageDetail.exchangeId),
                orderingOrderId: packageDetail.orderId,
                routeSequence: routeSequence,
                salColor: salColor,
                routeSortCode: createRouteSortCode(vehicleStopNumber, taskStopNumber),
                receivableAmount: packageDetail.receivableAmount,
                lockerName: packageDetail.lockerName,
                shipperName: packageDetail.shipperName,
                packageCount: packageDetail.packageCount,
                holderEmployeeStoreId: packageDetail.holderEmployeeStoreId,
                serviceType: serviceType,
                hazmatExceptions: hazmatExceptions,
                hazmatRegulatoryIds: hazmatRegulatoryIds
            }
        })
    }

    const renderSearchResultHeader = () => {
        return (
            <Fragment>
                <Column>
                    <Row>
                        <Text type="h500"><FormattedMessage id="search.package.searchTabResult_header" defaultMessage="Search Result"/></Text>
                        <Text type="h400">({sortedDisplayedList.length})</Text>
                    </Row>
                    <RefreshTimer deps={[packageList]}/>
                </Column>
                <Column
                    alignmentVertical="center"
                    alignmentHorizontal="right"
                    spacingInset="medium none none medium">
                        <Row wrap={isMobile? "down" : "none"}>
                            <Button type="tertiary" onClick={onClickOptionButton} ref={optionButtonRef}><FormattedMessage id="search.package.searchTabResult_viewOptions" defaultMessage="View Options"/></Button>
                            <Popover anchorNode={optionButtonRef.current} open={optionVisible} onClose={onCloseOptionButton} position="left" alignment="center">
                                <PopoverHeader closeLabel="Close"><FormattedMessage id="search.package.searchTab.result.availableColumns" defaultMessage="Available Columns"/></PopoverHeader>
                                <div style={{"overflowX": "scroll", "maxHeight": "300px"}}>
                                    <ControlGroup onChange={handleViewOptionsColumnChange} value={viewOptionColumns}>
                                        {displayViewOptions()}
                                    </ControlGroup>
                                </div>
                            </Popover>
                            <Button type="tertiary" onClick={() => setFilterWithinResult(!filterWithinResult)}><FormattedMessage id="search.package.searchTabResult_filterWithinResults" defaultMessage="Filter within Results"/></Button>
                                <Button type="tertiary" onClick={() => csvLink.current.link.click()}><FormattedMessage id="search.package.searchTab.result.exportToCSV" defaultMessage="Export to CSV"/></Button>
                                <CSVLink data={packageList} headers={headers.filter(searchColumn => viewOptionColumns.includes(searchColumn.label)).filter(searchColumn => searchColumn.label !== 'Select All')} ref={csvLink} filename="SearchResults.csv" target="_blank" fileEncoding="UTF-8"/>
                        </Row>
                </Column>
            </Fragment>
        )
    }

    return (
        <React.Fragment>
            <Toaster toasts={toasters} onCloseToast={() => setToasters([])} alignmentHorizontal="center">
                {(toast) => <Alert toast={true}>{toast.id}</Alert>}
            </Toaster>
            <Column>
                <Row spacingInset={spacingInset_shorthand6}>
                    <Textarea resize="none" value={inputValue} onChange={setInputValue} error={errorInput} placeholder={props.intl.formatMessage({id: 'search.package.searchTab_attrs'})} rows={5} width={isMobile ? "100%" : "300px"}/>
                </Row>
                <Row spacingInset="none none">
                    <Checkbox checked={columnCheck} onChange={setColumnCheck} size="medium"><Text color="secondary" type="b200"><FormattedMessage id="search.column_check" defaultMessage="Download Default columns only (Use when submitting >1000 TrackingIds  routing tasks to CO)"/></Text></Checkbox>
                </Row>
                <Row spacingInset="none none" alignmentHorizontal={isMobile? "center" : "start"}>
                    <Button onClick={onClickSearch}><FormattedMessage id="search.package.searchTab_search" defaultMessage="Search"/></Button>
                </Row>
                <CSVLink data={packageList} headers={!columnCheck ? headers.filter(header => header.label !== 'Select All') : headers.filter(header => defaultColumnOptions.includes(header.label))} ref={csvLink2} filename="SearchResults.csv" target="_blank" fileEncoding="UTF-8"/>
                {
                    loaderOn ? <Column widths="fill" alignmentVertical="center" alignmentHorizontal="center"><Loader {... loaderProgress > 0 ? {percentage:loaderProgress} : null} /></Column> :
                    (packageList.length && packageList.length <= batchSize) ? 
                    <Column spacingInline="large large large large">
                        <Row spacingInset="medium none">
                            <Divider />
                        </Row>
                        {
                            isMobile ?
                                <Column>
                                    {renderSearchResultHeader()}
                                </Column> :
                                <Row widths={["grid-8", "grid-4"]} spacingInset="none none none none">
                                    {renderSearchResultHeader()}
                                </Row>
                        }
                        {
                            filterWithinResult ? <Row widths="fill">
                                <Box type="fill" spacingInset="medium">
                                    <Row width="100%" widths="fill" wrap="down">
                                        <Select size="small" value={processedBySelectFilter} onChange={setProcessedBySelectFilter} placeholder={props.intl.formatMessage({id: 'search.package.searchTabResult_processedBy'})} >
                                            {packageList.map(packageDetail => packageDetail.lastProcessedByAssociateName).filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).map(lastProcessedByAssociateName => {
                                                return <SelectOption value={lastProcessedByAssociateName} label={lastProcessedByAssociateName}/>
                                            })}                                  
                                        </Select>
                                        <Select size="small" value={stationSelectFilter} onChange={setStationSelectFilter} placeholder={props.intl.formatMessage({id: 'search.package.searchTabResult_station'})}>
                                            {packageList.map(packageDetail => packageDetail.currentStationCode).filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).map(currentStationCode => {
                                                return <SelectOption value={currentStationCode} label={currentStationCode}/>
                                            })}                               
                                        </Select>                                                                               
                                        <Select size="small" value={routeSelectFilter} onChange={setRouteSelectFilter} placeholder={props.intl.formatMessage({id: 'search.package.searchTabResult_route'})}>
                                            {packageList.map(packageDetail => packageDetail.currentRouteCode).filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).map(currentRouteCode => {
                                                return <SelectOption value={currentRouteCode} label={currentRouteCode}/>
                                            })}                             
                                        </Select>
                                        <Select size="small" value={sortZoneSelectFilter} onChange={setSortZoneSelectFilter} placeholder={props.intl.formatMessage({id: 'search.package.searchTabResult_sortzone'})}>
                                            {packageList.map(packageDetail => packageDetail.assignedSortZone).filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).map(assignedSortZone => {
                                                return <SelectOption value={assignedSortZone} label={assignedSortZone}/>
                                            })}                             
                                        </Select>                                                         
                                    </Row>
                                </Box>
                            </Row> : null
                        }
                        <Column spacingInline="large large none large">
                            <Row widths={["grid-12"]} spacingInset="none none large none">
                                <div style={{"overflowX": "auto"}}>
                                    <Table spacing="small" sortColumn={sortState.sortColumn} sortDirection={sortState.sortDirection} headerRows={1} onSort={(data) => {
                                    setSortState(data)}}>
                                        <TableRow>

                                            {
                                                headers
                                                    .filter(searchColumn => searchColumn.label !== 'Select All')
                                                    .filter(searchColumn => viewOptionColumns.includes(searchColumn.label))
                                                    .map(searchColumn => {
                                                        return <TableCell minWidth={150} sortColumn={searchColumn.key} ><div style={{"whiteSpace": "nowrap"}}><Text type="h100"><FormattedMessage id={headersToStringId.find((header) => header.header === searchColumn.label).value} defaultMessage={headersToStringId.find((header) => header.header === searchColumn.label).header}/></Text></div></TableCell>
                                                    })
                                            }
                                        </TableRow>
                                        {
                                            sortedDisplayedList.map(packageDetail => {
                                            return <TableRow>   
                                                {viewOptionColumns.includes("Tracking ID") ? <TableCell alignmentVertical="top"><Link target = "_blank" rel="noreferrer noopener" href = {getPackageShareableLink(packageDetail.trackingId)}>{packageDetail.trackingId}</Link></TableCell> : null}
                                                {viewOptionColumns.includes('Last Updated Time') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.lastUpdatedTime)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Source') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.source)}</TableCell> : null}
                                                {viewOptionColumns.includes('State') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.currentPackageState)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Destination') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.destination)}</TableCell> : null}
                                                {viewOptionColumns.includes('Reason') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.reasonCode)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Station') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.currentStationCode)}</TableCell> : null}
                                                {viewOptionColumns.includes('Operation') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.operation)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Route Code') ? <TableCell alignmentVertical="top" >{handleBlankValue(packageDetail.currentRouteCode)}</TableCell> : null}
                                                {viewOptionColumns.includes('Last Scan By') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{fetchAssociate(searchPath, handleBlankValue(packageDetail.lastProcessedByAssociateName), packageDetail.lastUpdatedTime)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Address Type') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.addressType)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Ship Option') ? <TableCell alignmentVertical="top" ><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.shipOption)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Ship Method') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.shipMethod)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Delivery Destination Type') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.deliveryDestinationType)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Cluster') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.cluster)}</TableCell> : null}
                                                {viewOptionColumns.includes('Aisle') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.aisle)}</TableCell> : null}
                                                {viewOptionColumns.includes('Dispatch Time') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.dispatchTime)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('DSP Name') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.dspFlex)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Assigned Cycle') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.assignedCycle)}</TableCell> : null}
                                                {viewOptionColumns.includes('Inducted Cycle') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.inductedCycle)}</TableCell> : null}
                                                {viewOptionColumns.includes('Minutes in State') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.minutesInState)}</TableCell> : null}
                                                {viewOptionColumns.includes('Last Scan location') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.lastScanLocation)}</TableCell> : null}
                                                {viewOptionColumns.includes('Expected Next Location') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.expectedNextLocation)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Last Scan Status') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.lastScanStatus)}</TableCell> : null}
                                                {viewOptionColumns.includes('Payment Method') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.paymentMethod)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('District') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.district)}</TableCell> : null}
                                                {viewOptionColumns.includes('Shipment Type') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.shipmentType)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Ship Date') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.shipDate)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Scheduled Delivery Start Time') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.scheduledDeliveryStart)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Scheduled Delivery End Time') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.scheduledDeliveryEnd)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Promised Delivery Date') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.promisedDeliveryDate)}</div></TableCell> : null}
                                                {(isInternalPDDEnabled && viewOptionColumns.includes('Internal Promised Delivery Date')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.internalPromisedDeliveryDate)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Sort Zone') ? <TableCell alignmentVertical="top">{handleBlankValue(packageDetail.assignedSortZone)}</TableCell> : null}
                                                {viewOptionColumns.includes('Warehouse') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.warehouse)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Manifest Route Code') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.manifestRouteCode)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Order Amount') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.orderAmount)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Driver Id') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.driverId)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Package Length') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.packageLength)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Package Width') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.packageWidth)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Package Height') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.packageHeight)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Package Weight') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.packageWeight)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Estimated Arrival Date') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.estimatedArrivalDate)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Ordering Order ID') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.orderingOrderId)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Route Sequence') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.routeSequence)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Route Sort Code') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.routeSortCode)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Receivable Amount') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.receivableAmount)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Holder Name') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.lockerName)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('Service Type') ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.serviceType)}</div></TableCell> : null}
                                                {viewOptionColumns.includes('SAL Color') ?
                                                    <TableCell alignmentVertical="top">
                                                        {packageDetail.salColor.startsWith('#') ?
                                                            <Box backgroundColor={packageDetail.salColor} type="outline" spacingInset="medium large medium medium"></Box> :
                                                            <div style={{"whiteSpace": "nowrap"}} >{'-'}</div>
                                                        }
                                                    </TableCell>
                                                    : null}
                                                {(isShipperNameEnabled && viewOptionColumns.includes('Shipper Name')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.shipperName)}</div></TableCell> : null}
                                                {(addressFieldsEnabled && viewOptionColumns.includes('City')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.city)}</div></TableCell> : null}
                                                {(addressFieldsEnabled && viewOptionColumns.includes('Postal')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.postal)}</div></TableCell> : null}
                                                {(addressFieldsEnabled && viewOptionColumns.includes('Province')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.province)}</div></TableCell> : null}
                                                {(addressFieldsEnabled && viewOptionColumns.includes('Exchange')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.exchangeId)}</div></TableCell> : null}
                                                {(isINRegion() && viewOptionColumns.includes('Sort Location Label')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.sortLocationLabel)}</div></TableCell> : null}
                                                {(isINRegion() && viewOptionColumns.includes('Package Count')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.packageCount)}</div></TableCell> : null}
                                                {(isINRegion() && viewOptionColumns.includes('Store Name')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.holderEmployeeStoreId)}</div></TableCell> : null}
                                                {(hazmatVisibilityEnabled && viewOptionColumns.includes('Hazmat Exception')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.hazmatExceptions)}</div></TableCell> : null}
                                                {(hazmatVisibilityEnabled && viewOptionColumns.includes('Hazmat Label ID')) ? <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(packageDetail.hazmatRegulatoryIds)}</div></TableCell> : null}
                                            </TableRow>
                                            })
                                        }
                                    </Table> 
                                </div> 
                            </Row>
                        </Column>
                    </Column> : null
                } 
            </Column>
        </React.Fragment>
    );
};

export default injectIntl(PackageSearchTab);



// WEBPACK FOOTER //
// ./src/components/detailPages/searchTabs/PackageSearchTab.js